export default __webpack_public_path__ + "static/delegator-eca03ba50bd49f8e0838068531897a9c.png";